import { render, staticRenderFns } from "./CourseArticleView.vue?vue&type=template&id=3feb334d&scoped=true&"
import script from "./CourseArticleView.vue?vue&type=script&lang=js&"
export * from "./CourseArticleView.vue?vue&type=script&lang=js&"
import style0 from "./CourseArticleView.vue?vue&type=style&index=0&id=3feb334d&prod&scoped=true&lang=css&"
import style1 from "./CourseArticleView.vue?vue&type=style&index=1&id=3feb334d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb334d",
  null
  
)

export default component.exports